import React from "react";
import DocumentCard from "@components/DocumentCard/DocumentCard";
import type { VesselCertificate } from "@features/vessel-call/vessel-call-status/VesselCallStatus.types.tsx";
import { useDownloadCertificate } from "@pages/vessel-management/vessel-status/hooks/useDownloadCertificate";
import { t } from "i18next";

const TEST_ID_BASE = "vessel-call-status-page";
const certificatesTrans = "vessel-call";

interface Props {
  certificates?: VesselCertificate[];
}

const PreArrivalCertificates: React.FC<Props> = ({ certificates }) => {
  const { handleDownload, handlePreview } = useDownloadCertificate();

  const validCertificates = certificates?.filter((c): c is VesselCertificate => c !== null) ?? [];

  const isEmpty = validCertificates.length === 0;

  return (
    <div className="mt-6">
      {isEmpty ? (
        <div
          className="text-gray-500 font-normal text-sm"
          data-testid={`${TEST_ID_BASE}-certificates-empty`}
        >
          {t(`${certificatesTrans}.no-documents`)}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {validCertificates.map(
            (
              {
                certificateUrl,
                certificateDocumentName,
                certificateType,
                certificateClassName,
                certificateExpiryDate,
              },
              idx,
            ) => (
              <div key={`${certificateType}-${idx}`} className="w-full">
                <DocumentCard
                  testId={`${TEST_ID_BASE}-certificate-${certificateType}`}
                  title={t(`${certificatesTrans}.certificates.${certificateType}`)}
                  fileName={certificateDocumentName}
                  onDownload={() =>
                    handleDownload(
                      "certificate",
                      "bff-vessel",
                      certificateUrl,
                      certificateDocumentName,
                    )
                  }
                  onPreview={() => handlePreview("certificate", "bff-vessel", certificateUrl)}
                  className={certificateClassName}
                  expiryDate={certificateExpiryDate}
                />
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};
export default PreArrivalCertificates;
